import { ref, onMounted } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-06ad8b24"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-content"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "page-title"
}, "主体管理", -1));
const _hoisted_3 = {
  class: "filter-list-content"
};
const _hoisted_4 = {
  class: "input-select-content"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "list-title"
}, "条件：", -1));
const _hoisted_6 = {
  class: "btn-content"
};
import AccountTableBlock from '@/views/payManage/accountManage/components/AccountTableBlock.vue';
import { getPayChannel, getEntity, getEntityBuFen } from '@/api/payManage/accountManage';
import { OK } from '@/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const querySearch = ref({
      mchName: undefined,
      payChannel: undefined
    });
    const PayChannelList = ref([]);
    const EntityList = ref([]);
    const EntityListTable = ref([]);
    const accountTableRef = ref();
    const PayChannel = async () => {
        try {
          const {
            code,
            data
          } = await getPayChannel();
          if (code === OK) {
            PayChannelList.value = data.map(item => ({
              typeName: item.typeName == '抖音支付' ? '抖音/tiktok支付' : item.typeName,
              type: item.type
            }));
          }
        } catch (e) {}
      },
      Entity = async () => {
        try {
          const {
            code,
            data
          } = await getEntity();
          if (code === OK) {
            EntityList.value = data;
          }
        } catch (e) {}
      },
      EntityBuFen = async () => {
        try {
          const {
            code,
            data
          } = await getEntityBuFen();
          if (code === OK) {
            EntityListTable.value = data;
          }
        } catch (e) {}
      };
    const filterSubmit = params => {
      querySearch.value = params;
      accountTableRef.value.pageIndex = 1;
      accountTableRef.value.queryList(querySearch.value);
    };
    const filterOption = (input, option) => {
      var _option$typeName, _option$type;
      // 使用label或value进行搜索
      return (option === null || option === void 0 || (_option$typeName = option.typeName) === null || _option$typeName === void 0 ? void 0 : _option$typeName.toLowerCase().indexOf(input.trim().toLowerCase())) >= 0 || (option === null || option === void 0 || (_option$type = option.type) === null || _option$type === void 0 ? void 0 : _option$type.indexOf(input)) >= 0;
    }; // 模糊搜索
    onMounted(async () => {
      await PayChannel();
      await Entity();
      await EntityBuFen();
    });
    const changePageTableList = () => {
      accountTableRef.value.queryList(querySearch.value);
    };
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_a_select, {
        allowClear: "",
        showSearch: "",
        value: querySearch.value.mchName,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => querySearch.value.mchName = $event),
        placeholder: "主体",
        options: EntityListTable.value,
        "field-names": {
          label: 'typeName',
          value: 'typeName'
        }
      }, null, 8, ["value", "options"]), _createVNode(_component_a_select, {
        allowClear: "",
        showSearch: "",
        "filter-option": filterOption,
        value: querySearch.value.payChannel,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => querySearch.value.payChannel = $event),
        placeholder: "支付渠道",
        options: PayChannelList.value,
        "field-names": {
          label: 'typeName',
          value: 'type'
        }
      }, null, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_a_button, {
        onClick: _cache[2] || (_cache[2] = $event => filterSubmit({
          mchName: undefined,
          payChannel: undefined
        }))
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }), _createVNode(_component_a_button, {
        type: "primary",
        onClick: _cache[3] || (_cache[3] = $event => filterSubmit(querySearch.value))
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      })])])]), _createVNode(AccountTableBlock, {
        ref_key: "accountTableRef",
        ref: accountTableRef,
        PayChannelList: PayChannelList.value,
        EntityList: EntityList.value,
        onRefresh: _cache[4] || (_cache[4] = $event => filterSubmit({
          mchName: undefined,
          payChannel: undefined
        })),
        onChangePageTableList: changePageTableList
      }, null, 8, ["PayChannelList", "EntityList"])]);
    };
  }
});